import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter } from 'date-fns';

@Injectable({
    providedIn: 'root',
})
export class DateValidatorService {
    noFuture = ((
        control: AbstractControl<Date | undefined>,
    ): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }

        const date = new Date(control.value);

        if (isAfter(date, new Date())) {
            return { noFuture: true };
        }

        return null;
    }) satisfies ValidatorFn;
}
